export const GALLERY_TYPE = 'wix-draft-plugin-gallery';
